module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 说明：同一个用户可能有多个会员卡，积分多的是默认卡【也可以设置积分少的为默认卡】，商城上面扣积分和加积分都是针对的是默认卡片。 ")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户id"
    },
    model: {
      value: (_vm.params.user_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "user_id", $$v)
      },
      expression: "params.user_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户手机"
    },
    model: {
      value: (_vm.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "mobile", $$v)
      },
      expression: "params.mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button-group')], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "用户id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "npuserid",
      "label": "np用户id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardno",
      "label": "会员卡号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardtype",
      "label": "会员卡类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_card_time",
      "label": "开卡时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_card_time, 'yyyy-MM-dd hh:mm')))])]
      }
    }], null, false, 2092625997)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "同步到系统的时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.update_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 235244425)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "default_flag",
      "label": "默认卡片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.default_flag == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("默认卡")]) : _vm._e()]
      }
    }], null, false, 3916978845)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getRealTimePoint(scope.row.user_id, scope.row.cardno)
            }
          }
        }, [_vm._v("查看实时积分")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateUserPoint(scope.row.user_id, scope.row.mobile)
            }
          }
        }, [_vm._v("更新会员卡信息")]), _vm._v(" "), (scope.row.default_flag != 1) ? _c('el-button', {
          staticStyle: {
            "margin-left": "0"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.changeUserDefaultCard(scope.row.user_id, scope.row.cardno, scope.row.mobile)
            }
          }
        }, [_vm._v("\n                        更新为默认卡\n                    ")]) : _vm._e()]
      }
    }], null, false, 348533599)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "实时积分",
      "visible": _vm.realTimeDialog,
      "before-close": _vm.handleGetRealTimePoint,
      "width": "57%"
    },
    on: {
      "update:visible": function($event) {
        _vm.realTimeDialog = $event
      }
    }
  }, [
    [_c('el-row', {
      attrs: {
        "gutter": 100
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_vm._v("\n                        实时积分:" + _vm._s(_vm.realTimeData) + "\n                    ")])], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          return _vm.handleGetRealTimePoint.apply(null, arguments)
        }
      }
    }, [_vm._v("确定")])], 1)
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新会员卡信息【确认线上会员卡信息有误或者积分商城登录不上再做更新】",
      "visible": _vm.updateDialog,
      "before-close": _vm.handlechangeUpdate,
      "width": "60%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.updateDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.updateForm),
      callback: function($$v) {
        _vm.updateForm = $$v
      },
      expression: "updateForm"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 100
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "线上会员user_id"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "insiderid",
      "disabled": true
    },
    model: {
      value: (_vm.updateForm.user_id),
      callback: function($$v) {
        _vm.$set(_vm.updateForm, "user_id", $$v)
      },
      expression: "updateForm.user_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "mobile",
      "disabled": true
    },
    model: {
      value: (_vm.updateForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.updateForm, "mobile", $$v)
      },
      expression: "updateForm.mobile"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handlechangeUpdate.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateUserCardMess
    }
  }, [_vm._v("确定更新")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b718d6c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b718d6c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/duiba/members/list.vue
// module id = 2914
// module chunks = 0